import { useEffect, useState } from 'react';

import { InteractionManager, Keyboard } from 'react-native';

import { useSelector } from 'react-redux';

import { selectPlayerConfig } from 'store/player/selectors';
import { getModalVisible } from 'store/user/selectors';

import useNoInternet from 'utils/hooks/useNoInternet';
import { isWeb } from 'utils/responsiveness';

const useNoInternetAlertVisible = (isPlayerNotification: boolean) => {
    const { isInternetConnected } = useNoInternet();
    const { visible: playerVisible } = useSelector(selectPlayerConfig);
    const modalVisible = useSelector(getModalVisible);

    const [visible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        if (typeof isInternetConnected === 'boolean') {
            if (isPlayerNotification || modalVisible) {
                const newVisible = !isInternetConnected;

                if (newVisible && !visible) {
                    Keyboard.dismiss();
                    setVisible(true);
                } else if (!newVisible && visible) {
                    setVisible(false);
                }
            } else if (isWeb) {
                const newVisible =
                    !isInternetConnected && !playerVisible && !modalVisible;

                if (newVisible && !visible) {
                    setVisible(true);
                } else if (!newVisible && visible) {
                    setVisible(false);
                }
            } else {
                InteractionManager.runAfterInteractions(() => {
                    const newVisible =
                        !isInternetConnected && !playerVisible && !modalVisible;

                    if (newVisible && !visible) {
                        setVisible(true);
                    } else if (!newVisible && visible) {
                        setVisible(false);
                    }
                });
            }
        }
    }, [
        playerVisible,
        isInternetConnected,
        visible,
        isPlayerNotification,
        modalVisible,
    ]);

    return {
        visible,
    };
};

export default useNoInternetAlertVisible;
